<elder-table class="flex" matSort [data]="pkg().items" [idField]="'id'" [interactionMode]="'open'">
  <elder-data-toolbar
    *elderTableToolbar
    [canMore]="false"
    [canAdd]="false"
    [canRemove]="false"
  ></elder-data-toolbar>
  <!-- id Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'context.item' | translate }}
    </th>
    <td mat-cell *matCellDef="let pkgItem">
      <div class="layout-col">
        <span>{{ pkgItem.itemNumber }}</span>
        <span class="mat-caption">{{ pkgItem.itemId }}</span>
      </div>
    </td>
  </ng-container>
  <!-- product Column -->
  <ng-container matColumnDef="product">
    <th mat-header-cell *matHeaderCellDef style="width: 20%">
      {{ 'context.product' | translate }}
    </th>
    <td mat-cell *matCellDef="let pkgItem">
      <div class="layout-col">
        <span>{{ pkgItem.product.description }}</span>
        <span class="mat-caption">{{ pkgItem.product.materialId }}</span>
      </div>
    </td>
  </ng-container>
  <!-- quantity Column -->
  <ng-container matColumnDef="packagedQuantity">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="packagedQuantity.value">
      {{ 'context.quantity' | translate }}
    </th>
    <td mat-cell *matCellDef="let pkgItem">
      {{ pkgItem.packagedQuantity | elderQuantity }}
      / {{ pkgItem.product | productSalesQuantity | elderQuantity }}
    </td>
  </ng-container>
  <!-- weight Column -->
  <ng-container matColumnDef="weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="weight.value">
      {{ 'context.weight' | translate }}
    </th>
    <td mat-cell *matCellDef="let pkgItem">
      {{ pkgItem.weight | elderQuantity: { normalize: false, targetUnit: 'kg' } }}
      /
      {{ pkgItem.totalWeight | elderQuantity: { normalize: false, targetUnit: 'kg' } }}
    </td>
  </ng-container>
  <!-- hints Column -->
  <ng-container matColumnDef="hints">
    <th mat-header-cell *matHeaderCellDef>{{ 'context.hints' | translate }}</th>
    <td mat-cell *matCellDef="let pkgItem">
      <div class="layout-row place-start-center">
        @if (pkgItem.partial) {
          <mat-icon [matTooltip]="'context.subset' | translate">announcement </mat-icon>
        }
      </div>
    </td>
  </ng-container>
</elder-table>
